// Fetch the manifest, validate schema, persist to IndexedDB.

import { fetchJson, MANIFEST_PATH } from "../api/fetch";
import { MANIFEST_SCHEMA_VERSION, type Manifest } from "../feed/types";
import { replaceArticles, setMeta } from "../store/db";

export class StaleSchemaError extends Error {
  constructor(public got: number, public want: number) {
    super(`manifest schema_version ${got} > supported ${want}; refresh required`);
  }
}

export async function loadManifest(): Promise<Manifest> {
  const m = await fetchJson<Manifest>(MANIFEST_PATH);
  if (m.schema_version > MANIFEST_SCHEMA_VERSION) {
    throw new StaleSchemaError(m.schema_version, MANIFEST_SCHEMA_VERSION);
  }
  await replaceArticles(m.articles);
  await setMeta("schema_version", m.schema_version);
  await setMeta("generated_at", m.generated_at);
  await setMeta("last_manifest_fetch_ms", Date.now());
  return m;
}
